(function () {
  const STORAGE_KEY = 'hsh_discount_popup_dismissed';
  const PENDING_KEY = 'hsh_discount_popup_submit_pending';

  document.addEventListener(
    'submit',
    function (e) {
      var t = e.target;
      if (!t || t.id !== 'DiscountPopupNewsletter') return;
      try {
        sessionStorage.setItem(PENDING_KEY, '1');
      } catch (err) {
        /* ignore */
      }
      var btn = t.querySelector('.discount-popup__submit');
      if (btn) {
        btn.classList.add('loading');
        btn.setAttribute('aria-busy', 'true');
        var sp = btn.querySelector('.loading__spinner');
        if (sp) sp.classList.remove('hidden');
      }
    },
    true
  );

  function isPopupSuccessUrl() {
    try {
      var href = window.location.href;
      var search = window.location.search || '';
      var hash = window.location.hash || '';
      if (/[?&#]hsh_dp_success=1(?:&|$|#)/.test(href)) return true;
      if (/[?&]hsh_dp_success=1(?:&|$)/.test(search)) return true;
      if (hash === '#hsh_dp_success' || hash.indexOf('hsh_dp_success') !== -1) return true;
      return false;
    } catch (e) {
      return false;
    }
  }

  function showSuccessState(root) {
    var formPanel = root.querySelector('[data-discount-popup-form]');
    var successPanel = root.querySelector('[data-discount-popup-success]');
    if (!successPanel) return false;
    if (formPanel) formPanel.hidden = true;
    successPanel.hidden = false;
    root.setAttribute('data-popup-success', 'true');
    try {
      sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {
      /* ignore */
    }
    return true;
  }

  function isOurSuccess() {
    if (isPopupSuccessUrl()) return true;
    try {
      if (sessionStorage.getItem(PENDING_KEY) !== '1') return false;
    } catch (e) {
      return false;
    }
    try {
      var s = window.location.search || '';
      if (
        /[?&]customer_posted=true(?:&|$)/.test(s) ||
        /[?&]contact_posted=true(?:&|$)/.test(s)
      ) {
        try {
          sessionStorage.removeItem(PENDING_KEY);
        } catch (e2) {
          /* ignore */
        }
        return true;
      }
    } catch (e) {
      return false;
    }
    return false;
  }

  function init(root) {
    if (!root) return;

    try {
      if (root.querySelector('.discount-popup__form-errors')) {
        sessionStorage.removeItem(PENDING_KEY);
      }
    } catch (e) {
      /* ignore */
    }

    var delayMs = Math.max(0, parseInt(root.dataset.delayMs || '3000', 10) || 0);
    var designMode = document.documentElement.classList.contains('shopify-design-mode');
    var urlSuccess = isOurSuccess();
    var isSuccess = urlSuccess;

    if (!designMode && !isSuccess) {
      try {
        if (localStorage.getItem(STORAGE_KEY) === '1') {
          root.remove();
          return;
        }
      } catch (e) {
        /* ignore */
      }
    }

    var dialog = root.querySelector('.discount-popup__dialog');
    var closeBtn = root.querySelector('[data-discount-popup-close]');

    function open() {
      root.setAttribute('open', '');
      root.removeAttribute('hidden');
      var focusTarget = dialog && dialog.querySelector('input[type="email"], button, [tabindex="-1"]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    function closePersist() {
      root.removeAttribute('open');
      root.setAttribute('hidden', '');
      document.body.classList.remove('overflow-hidden');
      if (!designMode) {
        try {
          localStorage.setItem(STORAGE_KEY, '1');
        } catch (e) {
          /* ignore */
        }
      }
    }

    function onBackdropClick(e) {
      if (e.target === root) closePersist();
    }

    root.addEventListener('click', onBackdropClick);
    if (closeBtn) closeBtn.addEventListener('click', closePersist);

    root.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && root.hasAttribute('open')) closePersist();
    });

    if (designMode) {
      open();
      return;
    }

    if (urlSuccess) {
      showSuccessState(root);
      document.body.classList.add('overflow-hidden');
      open();
      var ok = root.querySelector('.discount-popup__success');
      if (ok) ok.focus({ preventScroll: true });
      return;
    }

    setTimeout(function () {
      document.body.classList.add('overflow-hidden');
      open();
    }, delayMs);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-discount-popup]').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target && ev.target.querySelector && ev.target.querySelector('[data-discount-popup]');
    if (root) init(root);
  });
})();
